import { FC } from 'react'

import { useGiftGivers } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/context/GiftGiversProvider'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Search } from 'baby-design'

import styles from '../GiftTrackerHeader.styles.scss'

const SearchFilter: FC = () => {
  const { setSearch } = useGiftGivers()

  return (
    <div className={styles.GiftTrackerHeader__Search}>
      <Search
        defaultText="Search gifts & people..."
        size="small"
        useSecondaryTrailingIcon={false}
        useTrailingIcon={false}
        variant="standard"
        onSubmit={setSearch}
      />
    </div>
  )
}

const SearchRow: FC = () => (
  <div className={styles.GiftTrackerHeader__SearchRow}>
    <SearchFilter />
  </div>
)

export default SearchRow
